import React, { Dispatch, useMemo } from 'react';
import { Cell, CellProps } from 'react-table';
import moment from 'moment/moment';

import { useI18n } from 'i18n';
import { IMonitoredVehicle } from 'types/vehicles-monitoring';
import { TableActionsCell } from 'components/molecules/table-actions-cell';
import { RemarksCell } from 'components/organisms/vehicles-monitoring/remarks-cell';
import { VehicleStatusCell } from 'components/organisms/vehicles-monitoring/status-cell';

export const useVehiclesMonitoringColumns = (
  onEdit: Dispatch<IMonitoredVehicle>,
  onDelete: Dispatch<IMonitoredVehicle>,
) => {
  const { fc } = useI18n();

  const getCell = ({ cell }: CellProps<IMonitoredVehicle>) => cell.value || '-';

  const getTrackerCell = ({ row }: CellProps<IMonitoredVehicle>) => {
    const { name, uri } = row.original.deviceInfo;

    return name || uri || '-';
  };

  const getRemarksCell = ({ cell }: CellProps<IMonitoredVehicle>) => <RemarksCell remarks={cell.value} />;

  const getStatusCell = ({ row }: CellProps<IMonitoredVehicle>) => (
    <VehicleStatusCell status={row.original.stateInfo?.status} statusAt={row.original.stateInfo?.sinceAt} />
  );

  const getDateCell = ({ cell }: CellProps<IMonitoredVehicle>) => (
    <>{cell.value ? moment(cell.value).format('DD/MM/YYYY, HH:mm:ss') : '-'}</>
  );

  const getActionsCell = ({ cell }: { cell: Cell<IMonitoredVehicle> }) => {
    const editAsset = () => onEdit(cell.row.original);
    const deleteAsset = () => onDelete(cell.row.original);

    return <TableActionsCell onEdit={editAsset} onDelete={deleteAsset} />;
  };

  return useMemo(
    () => [
      { Header: fc('ripple ID'), accessor: 'rippleId', width: 180, minWidth: 180, isFlexUnset: true },
      { Header: fc('tracker name'), accessor: 'tracker', Cell: getTrackerCell, width: 260, isFlexUnset: true },
      { Header: fc('remarks'), accessor: 'remarks', Cell: getRemarksCell, width: 265 },
      { Header: fc('versions'), accessor: 'version', Cell: getCell, width: 130, isFlexUnset: true },
      { Header: fc('status'), accessor: 'status', Cell: getStatusCell, width: 175, isFlexUnset: true },
      { Header: fc('created at'), accessor: 'createdAt', Cell: getDateCell, width: 190, isFlexUnset: true },
      {
        Header: fc('actions'),
        accessor: 'actions',
        width: 120,
        minWidth: 120,
        Cell: getActionsCell,
        isFlexUnset: true,
      },
    ],
    [],
  );
};
